export const githubAppManifest = (id: string) => ({
  name: `P0 ${id} machine access`,
  url: "https://p0.dev",
  hook_attributes: {
    url: "",
    active: false,
  },
  setup_url: "",
  description:
    "App used by P0 to provide machines access to your GitHub organization",
  public: false,
  default_events: [],
  default_permissions: {
    actions: "read",
    actions_variables: "read",
    administration: "read",
    artifact_metadata: "read",
    attestations: "read",
    checks: "read",
    code_quality: "read",
    codespaces: "read",
    codespaces_metadata: "read",
    contents: "read",
    dependabot_secrets: "read",
    deployments: "read",
    discussions: "read",
    enterprise_custom_org_roles: "read",
    enterprise_custom_properties_for_organizations: "read",
    enterprise_organization_installation_repositories: "read",
    enterprise_organization_installations: "read",
    enterprise_people: "read",
    enterprise_sso: "read",
    enterprise_teams: "read",
    environments: "read",
    issues: "read",
    license_compliance_alerts: "read",
    members: "read",
    merge_queues: "read",
    metadata: "read",
    organization_actions_variables: "read",
    organization_administration: "read",
    organization_custom_org_roles: "read",
    packages: "read",
    pages: "read",
    pull_requests: "read",
    repo_secret_scanning_dismissal_requests: "read",
    repository_custom_properties: "read",
    repository_hooks: "read",
    repository_projects: "read",
    secret_scanning_alerts: "read",
    secret_scanning_bypass_requests: "read",
    secrets: "read",
    security_events: "read",
    statuses: "read",
    vulnerability_alerts: "read",
    workflows: "write",
  },
});
